import { Search } from 'lucide-react';
import { useEffect, useState } from 'react';

interface GeoPoint {
  lat: any;
  lng: any;
  altitude?: any;
  accuracy?: any;
}

interface Props {
  disabled?: boolean;
  className?: string;
}

export default function GeopointInput({ disabled, className }: Props) {
  const [point, setPoint] = useState<GeoPoint>({
    lat: null,
    lng: null,
    altitude: null,
    accuracy: null,
  });
  const [currentLocation, setCurrentLocation] = useState<GeoPoint | null>(null);
  const update = (key: keyof GeoPoint, value: number) => {
    setPoint((p) => ({ ...p, [key]: value }));
  };
  useEffect(() => {
    navigator.geolocation?.getCurrentPosition(
      (pos) => setCurrentLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
      () => setCurrentLocation({ lat: 40.7128, lng: -74.006 }),
    );
  }, []);

  return (
    <div className="space-y-4">
      {/* Manual coordinates */}
      <div className="grid grid-cols-2 gap-3">
        <input
          type="number"
          placeholder="latitude (x,y)"
          className={className}
          value={point.lat}
          disabled={disabled}
          onChange={(e) => update('lat', Number(e.target.value))}
        />

        <input
          type="number"
          placeholder="longitude (x,y)"
          className={className}
          value={point.lng}
          disabled={disabled}
          onChange={(e) => update('lng', Number(e.target.value))}
        />

        <input
          type="number"
          placeholder="altitude (m)"
          className={className}
          value={point.altitude}
          disabled={disabled}
          onChange={(e) => update('altitude', Number(e.target.value))}
        />

        <input
          type="number"
          placeholder="accuracy (m)"
          className={className}
          value={point.accuracy}
          disabled={disabled}
          onChange={(e) => update('accuracy', Number(e.target.value))}
        />
      </div>

      {/* OR divider */}
      <div className="text-center text-xs text-gray-400">— or —</div>

      {/* Search */}
      <div className="relative">
        <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />

        <input
          type="text"
          placeholder="search for place or address"
          disabled={disabled}
          className={`${className} pl-8`}
        />
      </div>

      {/* Map */}
      <div className="h-[220px] w-full rounded-lg border overflow-hidden">
        {/* Replace with your map component */}
        <div className="flex items-center justify-center h-full text-gray-400 text-sm">
          {currentLocation && (
            <div className="h-60 border w-full border-[#C0275E] rounded-lg overflow-hidden">
              <iframe
                src={`https://www.openstreetmap.org/export/embed.html?bbox=${
                  currentLocation.lng - 0.01
                },${currentLocation.lat - 0.01},${currentLocation.lng + 0.01},${
                  currentLocation.lat + 0.01
                }&layer=mapnik&marker=${currentLocation.lat},${currentLocation.lng}`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                title="OpenStreetMap Preview"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
